import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // import styles
import { fleetrifyIcons } from "../../assets/icons/icons";

interface MetricCardProps {
  title: string;
  value: string | number;
  change?: number;
  isIncrease?: boolean;
  className?: string;
  loading?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  isIncrease,
  className,
  loading = false,
}) => {
  return (
    <button
      className={`bg-white hover:bg-[#1438871A] transition-all w-full px-12 cursor-pointer duration-300 shadow-sm p-6 ${className}`}
    >
      <h3 className="text-sm font-medium text-[13px] text-left text-[#333333] ">
        {title}
      </h3>
      <div className="mt-8 flex items-center justify-between">
        <p className="text-2xl font-bold text-[#00032A]">
          {loading ? <Skeleton width={60} /> : value}
        </p>
        {!loading && change !== undefined && (
          <div
            className={`flex items-center text-sm gap-1 font-medium ${
              isIncrease ? "text-green-500" : "text-red-500"
            }`}
          >
            {isIncrease ? (
              <figure>{fleetrifyIcons.increaseIcon}</figure>
            ) : (
              <figure>{fleetrifyIcons.decreaseIcon}</figure>
            )}
            {change}%
          </div>
        )}
      </div>
    </button>
  );
};

interface DashboardMetricsProps {
  metrics: {
    title: string;
    value: string | number;
    change?: number;
    isIncrease?: boolean;
  }[];
  headerText?: string;
  metricCardClassName?: string;
  loading?: boolean;
}

const DashboardMetrics: React.FC<DashboardMetricsProps> = ({
  metrics,
  headerText,
  metricCardClassName,
  loading = false,
}) => {
  return (
    <div className="mt-10 space-y-4 w-full">
      {headerText && <h3>{headerText || "Financial Summary Metrics"}</h3>}
      <div className="flex w-full">
        {metrics.map((metric, index) => (
          <MetricCard
            className={` ${metricCardClassName}
              ${index === 0 ? "rounded-l-lg" : "border-l"}
              ${index === metrics.length - 1 ? "rounded-r-lg" : ""}
            `}
            key={index}
            title={metric.title}
            value={metric.value}
            change={metric.change}
            isIncrease={metric.isIncrease}
            loading={loading}
          />
        ))}
      </div>
    </div>
  );
};

export default DashboardMetrics;
